@if (multiple) {
  <mat-form-field class="label-chip multiple-instance" [ngClass]="{ required: required }">
    <label>{{ placeholder | translate }}</label>
    <mat-chip-listbox>
      @for (item of multipleValue; track item) {
        <mat-chip-option (removed)="removeValue(item)" [removable]="true">
          {{ item?.title }} - {{ item?.code }}
          <fa-icon matChipRemove icon="times"></fa-icon>
        </mat-chip-option>
      }
      <button (click)="openDialog()" class="secondary" type="button">
        <fa-icon icon="plus-circle"></fa-icon>
      </button>
    </mat-chip-listbox>
  </mat-form-field>
} @else {
  <mat-form-field [ngClass]="{ required: required }" class="label-input single-instance">
    <label>{{ placeholder | translate }}</label>
    <input [required]="required" [disabled]="disabled" [value]="singleValue ? singleValue.title + ' - ' + singleValue.code : ''" matInput readonly />
    @if (!disabled) {
      @if (!readonly && !value) {
        <button (click)="openDialog()" class="primary" type="button">
          <fa-icon class="add-button" icon="plus-circle"></fa-icon>
        </button>
      } @else {
        @if (!readonly) {
          <button (click)="deleteSingleValue()" class="primary" type="button">
            <fa-icon class="add-button" icon="trash"></fa-icon>
          </button>
        }
      }
    }
  </mat-form-field>
}
